import { Container, Text, Graphics } from 'pixi.js';
import gsap from 'gsap';
import { ResizerDimensions, dimensions } from '../helpers/resizer';

class Hint extends Container {
  private hintText: Text;
  private hintContainer: Graphics;
  private showTimeout?: number;
  constructor() {
    super();

    this.hintContainer = new Graphics();
    this.hintContainer.beginFill('0xFFFFFF', 1);
    this.hintContainer.drawRoundedRect(0, 0, 450, 75, 20);
    this.hintContainer.endFill();

    this.hintText = new Text('', {
      fontFamily: 'Noto Sans',
      fontSize: '20px', //todo font size
      fill: '0x1e032b',
      wordWrap: true,
      wordWrapWidth: this.hintContainer.width,
    });
    this.hintText.anchor.set(0.5, 0.5);
    this.hintText.x = this.hintContainer.width / 2;
    this.hintText.y = this.hintContainer.height / 2;

    this.addChild(this.hintContainer);
    this.hintContainer.addChild(this.hintText);

    this.x = 30 * dimensions.scale;
    if (document.body.classList.contains('inside')) {
      this.y = 0.9 * ((dimensions.containerH - (45 + this.height) * dimensions.scale) / dimensions.scale);
    } else {
      this.y = (dimensions.containerH - (30 + this.height) * dimensions.scale) / dimensions.scale;
    }

    this.hintText.text = 'Najdi všechny předměty, které zvířátkům scházejí.';
  }

  public onResize = (resizerDimensions: ResizerDimensions) => {
    this.x = 30 * dimensions.scale;
    if (document.body.classList.contains('inside')) {
      this.y =
        0.9 * ((resizerDimensions.containerH - (45 + this.height) * resizerDimensions.scale) / resizerDimensions.scale);
    } else {
      this.y = (resizerDimensions.containerH - (30 + this.height) * resizerDimensions.scale) / resizerDimensions.scale;
    }
  };

  public showHint = (show: boolean) => {
    gsap.to(this.hintContainer, {
      duration: 1,
      ease: !show ? 'back.out' : 'back.in',
      alpha: !show ? 0 : 1,
    });

    if (this.showTimeout) {
      clearTimeout(this.showTimeout);
    }
    if (show) {
      this.showTimeout = setTimeout(() => {
        this.showHint(false);
        clearTimeout(this.showTimeout);
      }, 7500);
    }
  };
}

export default Hint;
